import { useAuth } from "./auth";
import { EMPRESA } from "./empresa";

export default function LoginPage() {
  const { login } = useAuth();
  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6" style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      {EMPRESA.logo ? (
        <img src={EMPRESA.logo} alt={EMPRESA.nombre} className="h-40 sm:h-48 w-auto object-contain mb-8" data-testid="login-logo" />
      ) : (
        <h1 className="text-white text-5xl sm:text-6xl font-bold tracking-[0.15em] mb-8" data-testid="login-logo">
          {EMPRESA.nombre}
        </h1>
      )}
      <p className="text-teal-300 text-xs uppercase tracking-[0.3em] font-medium mb-2">Sistema operativo</p>
      <p className="text-white text-lg mb-10">Inicia sesión con tu cuenta Google</p>
      <button
        onClick={login}
        data-testid="google-login-btn"
        className="bg-white hover:bg-slate-100 text-slate-800 font-semibold px-8 py-3 rounded-full shadow-lg flex items-center gap-3 transition-colors"
      >
        <svg width="20" height="20" viewBox="0 0 48 48">
          <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.2l6.7-6.7C35.5 2 30 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.2 17.7 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.5 24.5c0-1.7-.2-3.3-.4-4.9H24v9.3h12.7c-.6 3-2.3 5.6-4.9 7.3l7.6 5.9c4.4-4.1 7.1-10.1 7.1-17.6z"/>
          <path fill="#FBBC05" d="M10.5 28.7c-.6-1.7-.9-3.5-.9-5.4s.3-3.7.9-5.4l-7.9-6.1C1 15.7 0 19.7 0 24s1 8.3 2.6 12l7.9-6.1z"/>
          <path fill="#34A853" d="M24 48c6 0 11.5-2 15.4-5.5l-7.6-5.9c-2.1 1.4-4.8 2.2-7.8 2.2-6.3 0-11.6-3.7-13.5-9.8l-7.9 6.1C6.5 42.6 14.6 48 24 48z"/>
        </svg>
        Continuar con Google
      </button>
      <p className="text-slate-500 text-xs mt-8 max-w-xs text-center">
        Tu información se sincroniza automáticamente entre todos tus dispositivos
      </p>
    </div>
  );
}
